import { constants, actions } from 'ducks-helpers';

//  SUFFIXES
// [
//   'LOADING',
//   'PENDING',
//   'SUCCESS',
//   'ERROR',
//   'FAILED',
//   'CANCELED'
// ]

export const TYPE = constants('reports/transactions', [
    '~FETCH_TRANSACTIONS_REPORT',
    'EXPORT_TO_EXCEL'
]);

export const ACTION = actions(TYPE);
